// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"8":"8167959e","235":"b1356959","390":"db360cf9","524":"347f922d","647":"edd0bffe","655":"fefe3afd","674":"2f441ff6","785":"6753ee7a","807":"cf9fea60","879":"f2658ec7"}[chunkId] + ".js";
};